<template lang="nunjucks">
  <c-main>

    <h3>ID: {{member_data._id}} Ext. ID: {{member_data.user_id}}</h3>


    <c-row card>

      <c-col lg="9">
        <c-panel title="Recent Progressing Achievements">
          <ul class="list" style="height:200px;overflow:auto">
            <li class="list__item" v-for="progress of progressing_achievements">
              <c-level>
                <a :href="`/secure/achievements/edit/${progress.achievement_id}`" @click.prevent="$router.push(`/secure/achievements/edit/${progress.achievement_id}`)"  class="" slot="left"><i class="icon-clock u-color-green u-mr-5"></i>
                {{ progress.achievement_name }}
                <font style="color:#4caf50;margin-left:23px;display:block;font-size:70%"><c-progress-bar type="#397AF2" :value="progress.progress_percent"></c-progress-bar>{{progress.progress_percent}}% <span style="font-size:80%;text-transform: uppercase;color:#ccc;" v-if="progress.hidden_progress">Hidden Progress</span></font></a>
                
                <span slot="right" style="font-size:70%;text-align:right;" class="u-color-green" v-html="formatDateTime(progress.updated_date)">{{ formatDateTime(progress.updated_date) }}</span>
                
              </c-level>
            </li>
          </ul>
          <!--<div class="u-mb-15" v-for="achievement of member_achievements">
            <c-level>
              <span slot="left">{{ achievement.name }}</span>
              <span slot="right" class="u-color-muted">{{ member_data.achievement_progress[achievement._id].events_cnt }} / {{ achievement.conditions[0].main_rules[0].main_rule_val }}</span>
            </c-level>
            <c-progress-bar type="#397AF2" :value="member_data.achievement_progress[achievement._id].events_cnt / achievement.conditions[0].main_rules[0].main_rule_val * 100"></c-progress-bar>
          </div>-->
        </c-panel>
      </c-col>


      <c-col lg="9">
        <c-panel title="Recent Awarded Achievements">
          <ul class="list" style="height:200px;overflow:auto">
            <li class="list__item" v-for="reward of member_achievements">
              <c-level>
                <a :href="`/secure/achievements/edit/${reward.achievement_id}`" @click.prevent="$router.push(`/secure/achievements/edit/${reward.achievement_id}`)"  class="" slot="left"><i class="icon-wallet u-color-red u-mr-5"></i>{{ reward.achievement_name }}<font style="color:#4caf50;margin-left:23px;display:block;font-size:70%">{{ reward.achievement_id }}</font></a>
                <span slot="right" style="font-size:70%;text-align:right;" class="u-color-green" v-html="formatDateTime(reward.completed_date)">{{ formatDateTime(reward.completed_date) }}</span>
              </c-level>
            </li>
          </ul>
        </c-panel>
      </c-col>    
      

      <c-col lg="6">
        <c-panel title="Segments">
          <ul class="list" style="height:200px;overflow:auto">
            <li class="list__item" v-for="segment of member_segments">
              <c-level>
                <span class="u-inline-flex" slot="left"><i class="icon-drive u-color-green u-mr-5"></i>{{ segment.name }}</span>
                <span slot="right" class="u-color-green">{{ segment.id }}</span>
              </c-level>
            </li>
          </ul>
        </c-panel>
      </c-col>
    </c-row>

  <!--
    <c-panel title="Member Activities">
      <c-button-group slot="control">
        <c-button type="ghost" active>Week</c-button>
        <c-button type="ghost">Month</c-button>
        <c-button type="ghost">Year</c-button>
      </c-button-group>
      <x-activity-chart />
    </c-panel>-->


    <c-row card>
      <c-col lg="24">
        <c-panel title="Member events log">

        <data-table 
          v-bind:settings="eventsListSettings"
          ref="datatable">
          </data-table>

          
        </c-panel>
      </c-col>
    </c-row>
  </c-main>
</template>


<script>
import DataTables from "@/components/Tables";
import ActivityChart from "cover/site/routes/data/charts/basic.vue";
import data from "cover/site/routes/data/data.json";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "Dashboard",
  components: {
    "x-activity-chart": ActivityChart,
    "data-table": DataTables,
    moment: moment,
  },
  data() {
    return {
      member_data: {},
      member_segments: [],
      member_achievements: [],
      progressing_achievements: [],
      eventsListSettings: {
        scope: this,
        dataUrl: this.$cfg.API_URL + "/member-events/get-list/",
        order_by: { date_time: -1 },
        limit: 50,
        params: [{ member_id: this.$route.params.id }],
        search_by: 'q',
        cols: [
          {
            title: "DateTime",
            name: "date_time",
            sortable: true,
          },
          {
            title: "Event Name",
            name: "event_name",
            sortable: true,
            type: "render",
            render: function (row, col) {
              return (row.event_name && this.actionsMap[row.event_name]
                ? this.actionsMap[row.event_name].key : row.event_name) + (row.event_ext_id ? (" (" + row.event_ext_id + ")") : "");
            },
          },
          {
            title: "Event Value",
            name: "event_value",
            sortable: true,
          },
          {
            title: "Game",
            name: "game_id",
            sortable: true,
            type: "render",
            render: function (row, col) {
              return row.game_id && this.gamesMap[row.game_id]
                ? this.gamesMap[row.game_id].name +
                    " (" +
                    this.gamesMap[row.game_id].id +
                    ")"
                : row.game_id;
            },
          },
          {
            title: "Provider",
            name: "provider_id",
            sortable: true,
            type: "render",
            render: function (row, col) {
              return row.provider_id && this.providersMap[row.provider_id]
                ? this.providersMap[row.provider_id].name +
                    " (" +
                    this.providersMap[row.provider_id].id +
                    ")"
                : row.provider_id;
            },
          },
          {
            title: "Achievement",
            name: "achievement_id",
            sortable: true,
            type: "render",
            render: function (row, col) {
              return row.achievement_name
                ? row.achievement_name.replace(/;/gi, '<br>')
                : "";
            },
          },
        ],
        filterButtons: [
          {
            title: "All",
            code: "all",
            filter_rule: '{}',
          },
          {
            title: "Bet",
            code: "bet",
            filter_rule: '{"event": ["bet"]}',
          },
          {
            title: "Win",
            code: "win",
            filter_rule: '{"event": ["win"]}',
          },
          {
            title: "Awarded",
            code: "awarded",
            filter_rule: '{"event": ["awarded"]}',
          }
        ],
      },
    };
  },
  computed: {
    ...mapState(["gamesMap", "providersMap", "actionsMap"]),
  },
  methods: {
    slice(prop, start, end) {
      return this[prop].slice(start, end);
    },
    formatDateTime(date) {
      return moment(date).format("YYYY-MM-DD<br>HH:mm");
    },
  },
  async created() {
    const _this = this;

    //Getting user data
    await _this.$axios
      .post(_this.$cfg.API_URL + "/members/get-by-id", {
        query: [_this.$route.params.id],
      })
      .then((response) => {
        if (response.status == 200) {
          _this.member_data = response.data.data[0];
          return;
        }
      })
      .catch((err) => {
        console.log("Getting user data err:", err);
      });

    //Getting user segments based on segments ids
    await _this.$axios
      .post(_this.$cfg.API_URL + "/user-segments/get-segments-by-id", {
        ids: _this.member_data.segments,
      })
      .then((response) => {
        if (response.status == 200) {
          _this.member_segments = response.data.data;

          return;
        }
      })
      .catch((err) => {
        console.log("Getting segments data err:", err);
      });

    //Getting user achievements based on segments
    await _this.$axios
      .post(_this.$cfg.API_URL + "/achievements/get-awarded-achievements", {
        _user_id: _this.member_data._id,
      })
      .then((response) => {
        if (response.status == 200) {
          this.member_achievements = response.data.data;
          return;
        }
      })
      .catch((err) => {
        console.log("Getting segments data err:", err);
      });

    //Getting user achievements based on segments
    await _this.$axios
      .post(_this.$cfg.API_URL + "/achievements/get-progressing-achievements", {
        _user_id: _this.member_data._id,
      })
      .then((response) => {
        if (response.status == 200) {
          this.progressing_achievements = response.data.data;
          return;
        }
      })
      .catch((err) => {
        console.log("Getting segments data err:", err);
      });

  },
};
</script>
